export const TIME_RANGES = {
  TODAY: '1d',
  WEEK: '7d',
  MONTH: '30d',
} as const;

export type TimeRangeKey = typeof TIME_RANGES[keyof typeof TIME_RANGES];

export const API = {
  GET_DASHBOARD_SESSIONS: {
    path: '/chat-sessions/dashboard-stats/:productId',
    method: 'GET',
  },
};